// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"f0b7d005","372":"161a4f3b","409":"1beabf5e","610":"3ddbcc99"}[chunkId] + ".chunk.css";
};